var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatasets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 66,
    viewBox: "0 0 84 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_134",
    "data-name": "Group 134",
    transform: "translate(-176 -205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77",
    transform: "translate(911.339 -28.637)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M25.6,4.7c0-.017,0-.034,0-.051V0H2.082V4.651A2.1,2.1,0,0,1,0,6.766H27.679A2.1,2.1,0,0,1,25.6,4.7Z",
    transform: "translate(-683.679 254.871)",
    fill: "#00a9e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M2.079,2.064c0,.017,0,.034,0,.051V6.766H25.6V2.115A2.1,2.1,0,0,1,27.679,0H0A2.1,2.1,0,0,1,2.079,2.064Z",
    transform: "translate(-683.678 233.637)",
    fill: "#00a9e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M2.064,16.637l.051,0H6.766V2.044H2.115A2.08,2.08,0,0,1,0,0V18.679A2.078,2.078,0,0,1,2.064,16.637Z",
    transform: "translate(-688.339 238.298)",
    fill: "#cf451f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M6.766,4.651V0H2.115L2.064,0A2.109,2.109,0,0,0,0,2.105V4.651c0,.017,0,.034,0,.051A2.116,2.116,0,0,0,.634,6.163l0,0c.044.043.091.085.138.124s.087.067.132.1l.024.018a2.114,2.114,0,0,0,1.182.359H4.66A2.11,2.11,0,0,0,6.766,4.651Z",
    transform: "translate(-688.339 254.871)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M2.115,6.766H6.766V2.115c0-.017,0-.034,0-.051A2.109,2.109,0,0,0,4.661,0H2.115L2.064,0A2.117,2.117,0,0,0,.6.634l0,0Q.534.7.475.778C.44.82.408.864.377.909L.359.933A2.113,2.113,0,0,0,0,2.115V4.66A2.11,2.11,0,0,0,2.115,6.766Z",
    transform: "translate(-688.339 233.637)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M4.7,2.042l-.051,0H0v14.59H4.651a2.08,2.08,0,0,1,2.115,2.044V0A2.078,2.078,0,0,1,4.7,2.042Z",
    transform: "translate(-658.105 238.298)",
    fill: "#cf451f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M4.651,0H0V4.651c0,.017,0,.034,0,.051a2.109,2.109,0,0,0,2.1,2.064H4.651l.051,0a2.117,2.117,0,0,0,1.461-.632l0,0q.066-.067.125-.14c.034-.042.066-.085.1-.13l.019-.026a2.112,2.112,0,0,0,.359-1.182V2.105A2.11,2.11,0,0,0,4.651,0Z",
    transform: "translate(-658.105 254.871)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M6.132.6h0C6.085.557,6.038.515,5.988.474S5.9.408,5.857.377L5.833.359A2.114,2.114,0,0,0,4.651,0H2.106A2.11,2.11,0,0,0,0,2.115V6.766H4.651l.051,0a2.109,2.109,0,0,0,2.064-2.1V2.115c0-.017,0-.034,0-.051A2.116,2.116,0,0,0,6.132.6Z",
    transform: "translate(-658.105 233.637)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78",
    transform: "translate(864.339 9.363)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75-2",
    "data-name": "Path 75",
    d: "M25.6,4.7c0-.017,0-.034,0-.051V0H2.082V4.651A2.1,2.1,0,0,1,0,6.766H27.679A2.1,2.1,0,0,1,25.6,4.7Z",
    transform: "translate(-683.679 254.871)",
    fill: "#00a9e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86-2",
    "data-name": "Path 86",
    d: "M2.079,2.064c0,.017,0,.034,0,.051V6.766H25.6V2.115A2.1,2.1,0,0,1,27.679,0H0A2.1,2.1,0,0,1,2.079,2.064Z",
    transform: "translate(-683.678 233.637)",
    fill: "#00a9e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93-2",
    "data-name": "Path 93",
    d: "M2.064,16.637l.051,0H6.766V2.044H2.115A2.08,2.08,0,0,1,0,0V18.679A2.078,2.078,0,0,1,2.064,16.637Z",
    transform: "translate(-688.339 238.298)",
    fill: "#cf451f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95-2",
    "data-name": "Path 95",
    d: "M6.766,4.651V0H2.115L2.064,0A2.109,2.109,0,0,0,0,2.105V4.651c0,.017,0,.034,0,.051A2.116,2.116,0,0,0,.634,6.163l0,0c.044.043.091.085.138.124s.087.067.132.1l.024.018a2.114,2.114,0,0,0,1.182.359H4.66A2.11,2.11,0,0,0,6.766,4.651Z",
    transform: "translate(-688.339 254.871)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96-2",
    "data-name": "Path 96",
    d: "M2.115,6.766H6.766V2.115c0-.017,0-.034,0-.051A2.109,2.109,0,0,0,4.661,0H2.115L2.064,0A2.117,2.117,0,0,0,.6.634l0,0Q.534.7.475.778C.44.82.408.864.377.909L.359.933A2.113,2.113,0,0,0,0,2.115V4.66A2.11,2.11,0,0,0,2.115,6.766Z",
    transform: "translate(-688.339 233.637)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98-2",
    "data-name": "Path 98",
    d: "M4.7,2.042l-.051,0H0v14.59H4.651a2.08,2.08,0,0,1,2.115,2.044V0A2.078,2.078,0,0,1,4.7,2.042Z",
    transform: "translate(-658.105 238.298)",
    fill: "#cf451f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104-2",
    "data-name": "Path 104",
    d: "M4.651,0H0V4.651c0,.017,0,.034,0,.051a2.109,2.109,0,0,0,2.1,2.064H4.651l.051,0a2.117,2.117,0,0,0,1.461-.632l0,0q.066-.067.125-.14c.034-.042.066-.085.1-.13l.019-.026a2.112,2.112,0,0,0,.359-1.182V2.105A2.11,2.11,0,0,0,4.651,0Z",
    transform: "translate(-658.105 254.871)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105-2",
    "data-name": "Path 105",
    d: "M6.132.6h0C6.085.557,6.038.515,5.988.474S5.9.408,5.857.377L5.833.359A2.114,2.114,0,0,0,4.651,0H2.106A2.11,2.11,0,0,0,0,2.115V6.766H4.651l.051,0a2.109,2.109,0,0,0,2.064-2.1V2.115c0-.017,0-.034,0-.051A2.116,2.116,0,0,0,6.132.6Z",
    transform: "translate(-658.105 233.637)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    "data-name": "Group 79",
    transform: "translate(911.339 9.363)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75-3",
    "data-name": "Path 75",
    d: "M25.6,4.7c0-.017,0-.034,0-.051V0H2.082V4.651A2.1,2.1,0,0,1,0,6.766H27.679A2.1,2.1,0,0,1,25.6,4.7Z",
    transform: "translate(-683.679 254.871)",
    fill: "#00a9e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86-3",
    "data-name": "Path 86",
    d: "M2.079,2.064c0,.017,0,.034,0,.051V6.766H25.6V2.115A2.1,2.1,0,0,1,27.679,0H0A2.1,2.1,0,0,1,2.079,2.064Z",
    transform: "translate(-683.678 233.637)",
    fill: "#00a9e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93-3",
    "data-name": "Path 93",
    d: "M2.064,16.637l.051,0H6.766V2.044H2.115A2.08,2.08,0,0,1,0,0V18.679A2.078,2.078,0,0,1,2.064,16.637Z",
    transform: "translate(-688.339 238.298)",
    fill: "#cf451f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95-3",
    "data-name": "Path 95",
    d: "M6.766,4.651V0H2.115L2.064,0A2.109,2.109,0,0,0,0,2.105V4.651c0,.017,0,.034,0,.051A2.116,2.116,0,0,0,.634,6.163l0,0c.044.043.091.085.138.124s.087.067.132.1l.024.018a2.114,2.114,0,0,0,1.182.359H4.66A2.11,2.11,0,0,0,6.766,4.651Z",
    transform: "translate(-688.339 254.871)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96-3",
    "data-name": "Path 96",
    d: "M2.115,6.766H6.766V2.115c0-.017,0-.034,0-.051A2.109,2.109,0,0,0,4.661,0H2.115L2.064,0A2.117,2.117,0,0,0,.6.634l0,0Q.534.7.475.778C.44.82.408.864.377.909L.359.933A2.113,2.113,0,0,0,0,2.115V4.66A2.11,2.11,0,0,0,2.115,6.766Z",
    transform: "translate(-688.339 233.637)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98-3",
    "data-name": "Path 98",
    d: "M4.7,2.042l-.051,0H0v14.59H4.651a2.08,2.08,0,0,1,2.115,2.044V0A2.078,2.078,0,0,1,4.7,2.042Z",
    transform: "translate(-658.105 238.298)",
    fill: "#cf451f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104-3",
    "data-name": "Path 104",
    d: "M4.651,0H0V4.651c0,.017,0,.034,0,.051a2.109,2.109,0,0,0,2.1,2.064H4.651l.051,0a2.117,2.117,0,0,0,1.461-.632l0,0q.066-.067.125-.14c.034-.042.066-.085.1-.13l.019-.026a2.112,2.112,0,0,0,.359-1.182V2.105A2.11,2.11,0,0,0,4.651,0Z",
    transform: "translate(-658.105 254.871)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105-3",
    "data-name": "Path 105",
    d: "M6.132.6h0C6.085.557,6.038.515,5.988.474S5.9.408,5.857.377L5.833.359A2.114,2.114,0,0,0,4.651,0H2.106A2.11,2.11,0,0,0,0,2.115V6.766H4.651l.051,0a2.109,2.109,0,0,0,2.064-2.1V2.115c0-.017,0-.034,0-.051A2.116,2.116,0,0,0,6.132.6Z",
    transform: "translate(-658.105 233.637)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_80",
    "data-name": "Group 80",
    transform: "translate(864.339 -28.637)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75-4",
    "data-name": "Path 75",
    d: "M25.6,4.7c0-.017,0-.034,0-.051V0H2.082V4.651A2.1,2.1,0,0,1,0,6.766H27.679A2.1,2.1,0,0,1,25.6,4.7Z",
    transform: "translate(-683.679 254.871)",
    fill: "#00a9e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86-4",
    "data-name": "Path 86",
    d: "M2.079,2.064c0,.017,0,.034,0,.051V6.766H25.6V2.115A2.1,2.1,0,0,1,27.679,0H0A2.1,2.1,0,0,1,2.079,2.064Z",
    transform: "translate(-683.678 233.637)",
    fill: "#00a9e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93-4",
    "data-name": "Path 93",
    d: "M2.064,16.637l.051,0H6.766V2.044H2.115A2.08,2.08,0,0,1,0,0V18.679A2.078,2.078,0,0,1,2.064,16.637Z",
    transform: "translate(-688.339 238.298)",
    fill: "#cf451f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95-4",
    "data-name": "Path 95",
    d: "M6.766,4.651V0H2.115L2.064,0A2.109,2.109,0,0,0,0,2.105V4.651c0,.017,0,.034,0,.051A2.116,2.116,0,0,0,.634,6.163l0,0c.044.043.091.085.138.124s.087.067.132.1l.024.018a2.114,2.114,0,0,0,1.182.359H4.66A2.11,2.11,0,0,0,6.766,4.651Z",
    transform: "translate(-688.339 254.871)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96-4",
    "data-name": "Path 96",
    d: "M2.115,6.766H6.766V2.115c0-.017,0-.034,0-.051A2.109,2.109,0,0,0,4.661,0H2.115L2.064,0A2.117,2.117,0,0,0,.6.634l0,0Q.534.7.475.778C.44.82.408.864.377.909L.359.933A2.113,2.113,0,0,0,0,2.115V4.66A2.11,2.11,0,0,0,2.115,6.766Z",
    transform: "translate(-688.339 233.637)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98-4",
    "data-name": "Path 98",
    d: "M4.7,2.042l-.051,0H0v14.59H4.651a2.08,2.08,0,0,1,2.115,2.044V0A2.078,2.078,0,0,1,4.7,2.042Z",
    transform: "translate(-658.105 238.298)",
    fill: "#cf451f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104-4",
    "data-name": "Path 104",
    d: "M4.651,0H0V4.651c0,.017,0,.034,0,.051a2.109,2.109,0,0,0,2.1,2.064H4.651l.051,0a2.117,2.117,0,0,0,1.461-.632l0,0q.066-.067.125-.14c.034-.042.066-.085.1-.13l.019-.026a2.112,2.112,0,0,0,.359-1.182V2.105A2.11,2.11,0,0,0,4.651,0Z",
    transform: "translate(-658.105 254.871)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105-4",
    "data-name": "Path 105",
    d: "M6.132.6h0C6.085.557,6.038.515,5.988.474S5.9.408,5.857.377L5.833.359A2.114,2.114,0,0,0,4.651,0H2.106A2.11,2.11,0,0,0,0,2.115V6.766H4.651l.051,0a2.109,2.109,0,0,0,2.064-2.1V2.115c0-.017,0-.034,0-.051A2.116,2.116,0,0,0,6.132.6Z",
    transform: "translate(-658.105 233.637)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatasets);
export default __webpack_public_path__ + "static/media/datasets.da50af66a5cfed34ef2da9499fb2df28.svg";
export { ForwardRef as ReactComponent };